<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2023-03-30 14:33:08
 * @LastEditors: 刘小二
 * @LastEditTime: 2023-03-31 11:45:43
 * @Description: 工程调价 - 产品费用
 * @FilePath: /icps_pcweb/src/views/platform/ICPS/internetSales/dialog/productCostEng.vue
-->
<template>
    <div>
        <div style="display: flex; flex-direction: row; justify-content: flex-end; margin: 10px 0; padding-right: 10px;">
            <el-button v-if="!isLook" icon="el-icon-plus" size="small" class="bottom_all" style="margin-left: 0;" @click="addDialog(true)">设置产品价格</el-button>
        </div>
        <div>
            <el-table v-loading="tableLoading" :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width:100%;" height="350" :data="tableData" tooltip-effect="dark">
                <el-table-column v-for="(item, index) in table" :key="index" :prop="item.prop" :label="item.label" :width="item.width" align="center"  :fixed="item.label =='操作'?'right':false">
                    <template slot-scope="scope">
                        <div v-if="item.label == '操作'">
                            <el-button class="bottom_one" size="mini" @click="open(scope.row)"> 查看 </el-button>
                            <el-button v-if="!isLook" class="bottom_two" size="mini" @click="deleteFun(scope.row.id)"> 删除 </el-button>
                        </div>
                        <span v-else-if="item.label == '价格类型'">
                            {{ ["", "产品价格", "协商价格", "信息价格", "特殊价格"][scope.row.priceType * 1] }}
                        </span>
                        <span v-else-if="item.label == '状态'">
                            {{ ["待提交", "已通过"," 审核中","已拒绝"][scope.row.sureMaintain * 1] }}
                        </span>
                        <span  v-else>{{scope.row[item.prop] || '*'}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="card_bottom">
        <div class="card_bottom_left">
            <div class="top_page_totle">总共{{ total }}条</div>
            <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize" :page-sizes="[5,10, 20, 30, 40,50,100,200,500,1000]" layout="prev,pager,sizes,next,jumper" :total="total" @size-change="sizeChange" @current-change="queryResordPageFun()"></el-pagination>
            </div>
            <div>
            <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="queryResordPageFun">刷新</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { queryResordPage, delReadjustPricesResord } from "@/api/internetSales/engineeringControl.js";
export default {
    props: {
        engineeringId: {
            type: String,
            default: '',
        },
        isLook: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            tableParam: {
                page: 1,
                pageSize: 5,
                engineeringId: ''
            },
            table: [
                { label: "生效时间", width: "auto", prop: "effectiveTime", status: true },
                { label: "价格类型", width: "auto", prop: "priceType", status: true },
                { label: "税率", width: "auto", prop: "taxRate", status: true },
                { label: "维护人", width: "auto", prop: "createUserName", status: true },
                { label: "状态", width: "auto", prop: "sureMaintain", status: true },
                { label: "操作", width: "auto", prop: "", status: true },
            ],
            tableData: [],
            total: 0,
        }
    },
    methods: { 
        addDialog(val) {
            this.$emit('changeSetDialog',val)
        },
        open(val){
            console.log(' ------ ', val)
            this.$emit('openProductInfo',val)
        },
        deleteFun(val){
            delReadjustPricesResord({id : val}).then(res=>{
                if (res.code == 1001) {
                    this.queryResordPageFun()
                    this.$message({ message: "删除成功·", type: "success", });
                }
            })
        },
        queryResordPageFun(){
            this.tableParam.engineeringId = this.engineeringId
            queryResordPage(this.tableParam).then(res=>{
                if (res.code == 1001 && res.data) {
                    this.total = res.data.totalRows
                    this.tableData = res.data.data
                }
            })
        },
        sizeChange(value) {
            this.tableParam.pageSize = value;
            this.queryResordPageFun();
        },
    },
}

</script>

<style lang="scss" scoped>

</style>